import axios from "axios";
import { cmsHeaders } from "../exports/exports";
import { failed } from "../hooks/useToast";

export const fetchCompanyDetails = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/company-details`,
      { headers: cmsHeaders },
    );
    return response.data.slice(-1);
  } catch (error) {
    console.error("Server Error", error);
    failed();
  }
};
